import Settings from '@/config/Settings.js'
import MusicCaptations from '@/components/music/music/captations.js'
import _ from 'lodash'
import Agent from '@/core/js/Agent'
import {cdn} from '@/commons/js/Utils'

const captations = MusicCaptations

let imgFolder = Agent.mobile ? './img_1024/' : './img/'
if(AFRAME.utils.device.isGearVR())
  imgFolder = './img_1024/'

_.each(captations, c => {
  c.viewed = false
  c.clicked = false
  c.isShow = false
  c.sound = { type: 'captations', sprite: c.name },
  c.img = {
    silhouette: cdn(require(imgFolder + c.name + '_cut.png')),
    full: cdn(require(imgFolder + c.name + '.png')),
  }
})

captations.push({
  name: 'intro-3',
  position: { x: 0.505, y: 1.304, z: -7.526 },
  is_focus: { fr: false, en: false },
  viewed: false,
  clicked: false,
  isShow: false,
  level: 'intro-3',
  sound: { type: 'narrations_', sprite: 'Intro_Part2' },
  img: {
    silhouette: cdn(require(imgFolder + 'tutorial_cut.png')),
    full: cdn(require(imgFolder + 'tutorial.png')),
  }
})

export default captations

// export default _.groupBy(MusicCaptations, m => m.level)




// WEBPACK FOOTER //
// ./src/components/captation/Captations.js